import React, {Component} from 'react';
import ProductEntitlementOverview from './ProductEntitlementOverview';
import VirtualAccount from './VirtualAccount';
import PaymentAndUsageHistory from './PaymentAndUsageHistory/index';
import './usageStatus.scss';
import {Route} from 'react-router-dom';
import {PageContainer, PageTitle} from '../../Common/PageComponents';

class UsageStatus extends Component {
  render() {
    return (
      <PageContainer>
        <PageTitle title="결제 및 사용 내역" data-qa="usagePageTitle" />
        <ProductEntitlementOverview />
        <VirtualAccount />
        <Route
          path="/my-pc-bang/usage-status/payment-and-billing/:category?/:pageNumber?"
          component={PaymentAndUsageHistory}
        />
      </PageContainer>
    );
  }
}

export default UsageStatus;
